export default "__VITE_ASSET__CkDSUMCj__"